import {
  LOAD_PAYMENT_METHODS,
  SET_PAYMENT_METHODS,
  SET_UPDATED_PAYMENT_METHOD,
  REMOVE_PAYMENT_METHOD,
  ADDING_NEW_PAYMENT_METHOD,
  LOAD_INVOICES,
  SET_INVOICES,
  LOAD_PLANS,
  SET_PLANS,
  LOAD_SUBSCRIPTION_INFO,
  SET_SUBSCRIPTION_INFO,
  UPDATING_SUBSCRIPTION_INFO,
  SET_SELECTED_PLAN_IF_NO_PAYMENT_METHODS,
  LOAD_SUBSCRIPTION_ALERTS,
  SET_SUBSCRIPTION_ALERTS,
  RESET_BILLING_STATE,
  SET_PAYMENT_METHOD_COUNT,
  INVOICE_PAGINATION_COUNT
} from '@/state/mutationTypes'
import getBillingStoreDefaultState from '@/state/billingStore/billingStoreDefaultState'

export default {
  [LOAD_PAYMENT_METHODS](state, payload) {
    state.loadPaymentMethods = payload
  },
  [SET_PAYMENT_METHODS](state, payload) {
    state.paymentMethods = [...payload]
  },
  [SET_UPDATED_PAYMENT_METHOD](state, payload) {
    let paymentMethods = [...state.paymentMethods]
    paymentMethods.forEach(method => {
      return {
        id: method.id,
        sourceType: method.sourceType,
        lastFour: method.last4,
        brand: method.brand,
        isPrimary: (method.isPrimary = method.id === payload.id),
        canBeRemoved: method.id === payload.id ? false : true
      }
    })
    state.storeInventoryList = [...paymentMethods]
  },
  [REMOVE_PAYMENT_METHOD](state, payload) {
    let paymentMethods = [...state.paymentMethods]
    paymentMethods = paymentMethods.filter(method => method.id !== payload)
    state.paymentMethods = [...paymentMethods]
  },
  [ADDING_NEW_PAYMENT_METHOD](state, payload) {
    state.submittingPaymentMethod = payload
  },
  [LOAD_INVOICES](state, payload) {
    state.loadInvoices = payload
  },
  [SET_INVOICES](state, payload) {
    state.invoices = [...payload]
  },
  [LOAD_PLANS](state, payload) {
    state.loadPlans = payload
  },
  [SET_PLANS](state, plans) {
    state.plans = plans
  },
  [LOAD_SUBSCRIPTION_INFO](state, payload) {
    state.loadingSubscription = payload
  },
  [SET_SUBSCRIPTION_INFO](state, payload) {
    state.currentSubscription = { ...payload }
  },
  [UPDATING_SUBSCRIPTION_INFO](state, payload) {
    state.updatingCurrentSubscription = payload
  },
  [SET_SELECTED_PLAN_IF_NO_PAYMENT_METHODS](state, payload) {
    state.selectedPlanIfNoPaymentsCreated = payload
  },
  [LOAD_SUBSCRIPTION_ALERTS](state, payload) {
    state.loadSubscriptionAlerts = payload
  },
  [SET_SUBSCRIPTION_ALERTS](state, alerts) {
    state.subscriptionAlerts = alerts
  },
  [RESET_BILLING_STATE](state) {
    Object.assign(state, getBillingStoreDefaultState())
  },
  [SET_PAYMENT_METHOD_COUNT](state, payload) {
    state.paymentMethodCount = payload
  },
  [INVOICE_PAGINATION_COUNT](state, payload) {
    state.invoiceCount = payload
  }
}
